export const CAMPAIGN_LOAD_ERROR_MESSAGE =
  '読み込みに失敗しました。\n再度時間を置いてお試しください。';

const CAMPAIGN_LIST_ERROR_CODES = new Set([
  'CAMPAIGN_LIST_ERROR',
  'USER_CAMPAIGN_LIST_ERROR',
]);

/**
 * toCampaignListErrorMessage
 *
 * Converts the campaign list error code to the error message
 * @param errorCode - the error code to convert
 * @returns the error message
 */
export function toCampaignListErrorMessage(
  errorCode: string
): string | undefined {
  return CAMPAIGN_LIST_ERROR_CODES.has(errorCode)
    ? CAMPAIGN_LOAD_ERROR_MESSAGE
    : undefined;
}
